import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { Tags as TagsCollection } from '@feathr/blackbox';
import { Pill } from '@feathr/components';
import { useStore } from '@feathr/extender/state';

import * as styles from './Tags.css';

interface IProps {
  className?: string;
  /** Defaults to the store's. */
  collection?: TagsCollection;
  value: string[];
}

function Tags({ className, collection, value }: Readonly<IProps>): JSX.Element {
  const { Tags: storeTags } = useStore();
  const tags = collection ?? storeTags;
  return (
    <div className={classNames(styles.root, className)}>
      {value.map((tagId: string) => {
        const tag = tags.get(tagId);
        return (
          <Pill key={tagId} theme={'neutral'}>
            {tag.name}
          </Pill>
        );
      })}
    </div>
  );
}

export default observer(Tags);
